import axios from 'axios'

class ProcedureUserService{
    constructor(apiUrl){
        this.apiUrl = apiUrl
    }

    /**
    * @author Edgar Escobedo
    * @description GET information user procedure by id
    * @date 08-02-2024
    * @param {String} token
    * @returns {Object}
    * @memberof ProcedureUserService
    */
    async getProcedureUserData(procedureUserId, token){
    let response = await axios.get(
        `${this.apiUrl}/procedure-user?procedureUserId=${procedureUserId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
   }

  /**
  * @author Edgar Escobedo
  * @description Update information user procedure by id
  * @date 08-02-2024
  * @param {Number} procedureUserId
  * @param {Object} info
  * @param {String} token
  * @returns {Object}
  * @memberof ProcedureUserService
  */
  async updateProcedureUser(procedureUserId, info, token){
    let response = await axios.put(
      `${this.apiUrl}/procedure-user`,
        { procedureUserId, info },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description workflow procedure user
  * @date 08-02-2024
  * @param {Number} procedureUserId
  * @param {UUID} workflowExecutionId
  * @param {String} action
  * @param {Number} statusDefined
  * @param {String} token
  * @returns {Object}
  * @memberof ProcedureUserService
  */
  async callProcedureUserWorkflow(procedureUserId, workflowExecutionId, action, statusDefined, token, documents){
    let response = await axios.post(
      `${this.apiUrl}/procedure-user-workflow`,
        { procedureUserId, workflowExecutionId, action, statusDefined, documents },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description Upload document procedure user
  * @date 09-02-2024
  * @param {Number} procedureUserId
  * @param {UUID} workflowExecutionId
  * @param {String} action
  * @param {Number} statusDefined
  * @param {String} token
  * @returns {Object}
  * @memberof ProcedureUserService
  */
  async uploadDocumentProcedureUser(userDocument, token){
    let response = await axios.post(
      `${this.apiUrl}/procedure-user-document`,
        userDocument,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description update userClientDocument form answered
  * @date 24-01-2024
  * @param {Number} id
  * @param {Boolean} answwer
  * @param {String} token
  * @returns {Object}
  * @memberof ProcedureUserService
  */
  async udpateformAnswered(id, answer, token){
    let response = await axios.post(`${this.apiUrl}/form-answered`,
      { id, answer },
      {
        headers:{
          Authorization: `Bearer ${token}`
        }
      }
    )

    return response.data
  }
}

export { ProcedureUserService as default }